export default "__VITE_ASSET__CA02VMG___"